export default __webpack_public_path__ + "static/media/gallery-wip-pommel-cap_06.9415f259.jpg";